import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {RecordData, RecordsDataRequestQueryParams} from '../../../../types/records-table.types';
import { baseUrl } from '../../../../constants/base-url';
import {resources} from "../../../../models/resource/resources";


@Injectable({
  providedIn: 'root'
})
export class RepeatsModalService {
  private http: HttpClient = inject(HttpClient);

  public getRepeatsForRecordsList(recordId: number): Observable<Array<RecordData>> {
    return this.http.get<Array<RecordData>>(`${baseUrl}/${resources['record-lists'].path}/repeats/${resources['record-lists'].path}/${recordId}`);
  }

  public getSearchRepeatsForRecordsList(queryParams: RecordsDataRequestQueryParams): Observable<Array<RecordData>> {
    return this.http.get<Array<RecordData>>(`${baseUrl}/${resources['record-lists'].path}/repeats/search`, {
      params: queryParams
    });
  }

  public getRepeatsForCalendarList(recordId: number): Observable<Array<RecordData>> {
    return this.http.get<Array<RecordData>>(`${baseUrl}/${resources['record-lists'].path}/repeats/${resources['record-calendars'].path}/${recordId}`);
  }
}
